import { compose } from 'ramda';

import withFacebookAnalytics from 'app/analytics/enhancers/withFacebookAnalytics';
import { withGoogleAdWordsConversion } from 'app/analytics/enhancers/withGoogleAdWordsAnalytics';
import withTradeDeskConversionAnalytics from 'app/analytics/enhancers/withTradeDeskConversionAnalytics';
import withCriteoTagTracker from 'app/analytics/enhancers/withCriteoAnalytics';
import { SALES_TAG } from 'app/analytics/constants/criteo';
import withTwitterConversionAnalytics from 'app/analytics/enhancers/withTwitterConversionAnalytics';

const withTrackConversion = compose(
  withFacebookAnalytics,
  withGoogleAdWordsConversion,
  withTradeDeskConversionAnalytics,
  withCriteoTagTracker(SALES_TAG),
  withTwitterConversionAnalytics,
);

export default withTrackConversion;
